import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.template && _vm.template.deviceMeta ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "7",
      "lg": "7",
      "sm": "7"
    }
  }, [_c('core-device-template-key-value-editor', {
    attrs: {
      "deviceMeta": _vm.template.deviceMeta,
      "property": 'referenceIds',
      "isProductiveVersion": _vm.isProductiveVersion,
      "readonly": _vm.readonly,
      "header": _vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.header'),
      "description": _vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.specifyReferenceIds'),
      "keyLabel": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.referenceKey'),
      "valueLabel": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.referenceValue')
    },
    model: {
      value: _vm.template.deviceMeta.referenceIds,
      callback: function ($$v) {
        _vm.$set(_vm.template.deviceMeta, "referenceIds", $$v);
      },
      expression: "template.deviceMeta.referenceIds"
    }
  })], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };